export enum LoanOriginationSystemBorrowersFiltersActionTypes {
  SetSearchInputValue = 'loanOriginationSystemBorrowersFilters/setSearchInputValue',
  ToggleFiltersPopup = 'loanOriginationSystemBorrowersFilters/toggleFiltersPopup',
  ChangePopupFilters = 'loanOriginationSystemBorrowersFilters/changePopupFilters',
  FilterBorrowersByMembers = 'loanOriginationSystemBorrowersFilters/filterBorrowersByMembers',
  ResetAllFilters = 'loanOriginationSystemBorrowersFilters/resetAllFilters',
}
